define('areas/home/model/livetilecacheitem',["require", "exports"], function (require, exports) {
    "use strict";
    var LiveTileCacheItem = (function () {
        function LiveTileCacheItem() {
            this.isInvalidated = false;
        }
        return LiveTileCacheItem;
    }());
    return LiveTileCacheItem;
});

